<template>
  <svg class="w-6" width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 8.15886H15.9833L11.7171 12.3611L13.3809 14L20 6.9984L13.3809 0L11.7171 1.63887L15.9833 5.84114H0V8.15886Z"
      fill="white"
    />
  </svg>
</template>
